import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  navGroup: 'data-accordion-nav-group',
}
const qsAll = {
  containers: 'data-accordion-group',
  details: 'data-accordion-details',
  toggles: 'data-accordion-summary',
  contents: 'data-accordion-content',
  navs: 'data-accordion-nav',
}

const initAccordion = (accordionGroup) => {
  const state = {
    group: accordionGroup,
    details: accordionGroup.querySelectorAll(`[${qsAll.details}]`),
    toggles: accordionGroup.querySelectorAll(`[${qsAll.toggles}]`),
    contents: accordionGroup.querySelectorAll(`[${qsAll.contents}]`),
  }

  const open = (i) => {
    const detail = state.details[i]
    const toggle = state.toggles[i]
    const content = state.contents[i]
    
    // If applicable, hide all the other details first
    if (state.settings.one_visible) {
      for (let a = 0; a < state.toggles.length; a++) {
        if (i !== a) close(a)
      }
    }
    
    // Update class
    if(detail) detail.classList.remove("is-closing")
    
    // Get height of toggle
    const toggle_height = toggle.clientHeight
    
    // Momentarily show the contents just to get the height
    detail.setAttribute("open", true)
    const content_height = content.clientHeight
    detail.removeAttribute("open")
    
    // Set the correct height and let CSS transition it
    detail.style.height = toggle_height + content_height + "px"
    
    // Finally set the open attr
    detail.setAttribute("open", true)
  }

  const close = (i) => {
    const detail = state.details[i]
    const toggle = state.toggles[i]
    
    // Update class
    detail.classList.add("is-closing")
    
    // Get height of toggle
    const toggle_height = toggle.clientHeight
    
    // Set the height so only the toggle is visible
    detail.style.height = toggle_height + "px"
    setTimeout(() => {
      // Check if still closing
      if (detail.classList.contains("is-closing"))
        detail.removeAttribute("open")
        detail.classList.remove("is-closing")
    }, state.settings.speed)
  }


  // Set default settings if necessary
  state.settings = {
    speed: 500,
    one_visible: true
  }
  
  // Setup inital positions
  for (let i = 0; i < state.details.length; i++) {
    const detail  = state.details[i]
    const toggle  = state.toggles[i]
    const content = state.contents[i]
    
    // Set transition-duration to match JS setting
    detail.style.transitionDuration = state.settings.speed + "ms"
    
    // Set initial height to transition from
    if (!detail.hasAttribute("open")) {
      detail.style.height = toggle.clientHeight + "px"
    } else {
      detail.style.height = toggle.clientHeight + content.clientHeight + "px"
    }
  }
  
  // Setup click handler
  state.group.addEventListener("click", (e) => {
    if (e.target.hasAttribute(`${qsAll.toggles}`) || (e.target.closest('summary') && e.target.closest('summary').hasAttribute(`${qsAll.toggles}`))) {
      e.preventDefault()

      let num = 0
      for (let i = 0; i < state.toggles.length; i++) {
        if (state.toggles[i] === e.target || (e.target.closest('summary') && e.target.closest('summary') == state.toggles[i])) {
          num = i
          break
        }
      }

      if (!e.target.closest('details').hasAttribute("open")) {
        open(num)
      } else {
        close(num)
      }
    }
  })
}

window.initAccordion = initAccordion

const elementInViewport = (el) => {
  var top = el.offsetTop
  var left = el.offsetLeft
  var width = el.offsetWidth
  var height = el.offsetHeight
  const pageYOffSet = window.scrollY || window.pageYOffSet
  const pageXOffset = window.scrollX || window.pageXOffset
  while(el.offsetParent) {
    el = el.offsetParent
    top += el.offsetTop
    left += el.offsetLeft
  }

  return (
    top >= pageYOffSet &&
    left >= pageXOffset &&
    (top + height) <= (pageYOffSet + window.innerHeight) &&
    (left + width) <= (pageXOffset + window.innerWidth)
  )
}

const updateScrolledSection = () => {
  let current = dom.containers[0].getAttribute("id")
  let containerFound = false
  dom.containers.forEach(container => {
    if(elementInViewport(container)) {
      if(!containerFound) {
        current = container.getAttribute("id")
        containerFound = true
      }
    }
  })
  dom.navs.forEach((nav) => {
    nav.querySelector('.icon').classList.add("hidden")
    if (nav.dataset.accordionTarget == current) {
      nav.querySelector('.icon').classList.remove("hidden")
    }
  })
}

export const setupAccordions = () => {
  cacheDom(dom, qs, qsAll)
  dom.containers.forEach(container => initAccordion(container))
  if(dom.navGroup && dom.containers.length > 0) {
    window.addEventListener('scrollend', () => {
      updateScrolledSection()
    })
    dom.navs.forEach(nav => {
      nav.addEventListener('click', () => {
        const id = nav.dataset.accordionTarget
        const group = document.querySelector(`#${id}`)
        if(group) {
          window.scrollTo({
            top: group.offsetTop - 80,
            left: 0,
            behavior: "smooth",
          })
        }
      })
    })
  }
  if(location.hash && location.hash.includes('#') && document.querySelector(location.hash)) {
    setTimeout(() => {
      window.scrollTo({
        top: document.querySelector(location.hash).offsetTop - 80,
        left: 0,
        behavior: "smooth",
      })
    }, 500)
  }
}